import { render, staticRenderFns } from "./ClientExport.vue?vue&type=template&id=0616e1da&"
import script from "./ClientExport.vue?vue&type=script&lang=js&"
export * from "./ClientExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports